import { ratingReport } from "./rating.service";
import { downloadXLS } from "./excel.service";

function formatNameField({ userSurname, userName, userPatronymic } = {}) {
  return `${userSurname || ""} ${userName || ""} ${userPatronymic ||
    ""}`.trim();
}

function formatIndex(array, label) {
  let first = true;
  let result = "";
  for (let i = 0; i < array.length; i++) {
    if (array[i].label == label) {
      if (first) {
        result = `${array[i].index}`;
        first = false;
      } else {
        result = `${result}x${array[i].index}`;
      }
    }
  }
  return result;
}

function sortByKey(array, key) {
  return array.sort(function(a, b) {
    var x = a[key];
    var y = b[key];
    return x > y ? -1 : x < y ? 1 : 0;
  });
}

function formatRows(data) {
  let rows = [
    [
      {
        value: "№",
        width: 5,
        align: "center"
      },
      {
        value: "ФИО",
        width: 35,
        align: "center"
      },
      {
        width: 20
      },
      {
        value: "баллы",
        align: "center",
        width: 6
      },
      {
        width: 5
      },
      {
        width: 7
      },
      {
        width: 7
      },
      {
        width: 4
      },
      {
        width: 10
      }
    ]
  ];

  let totalSum = 0;
  let totalCount = 0;
  data.forEach(element => {
    rows.push([
      {
        colspan: 4,
        header: true,
        align: "center"
      },
      {},
      {},
      {
        value: element.activityName,
        align: "center"
      },
      {
        value: "н",
        align: "center"
      },
      {
        value: "к",
        align: "center"
      },
      {
        value: "б",
        align: "center"
      }
    ]);
    let index = 1;
    // let activityIndex = element.activityIndex;

    sortByKey(element.items, "points").forEach(item => {
      rows.push([
        {
          value: index++,
          align: "center"
        },
        {
          value: formatNameField(item)
        },
        {
          value: item.description,
          align: "center"
        },
        {
          value: item.points,
          align: "center"
        },
        { value: element.activityIndex, align: "center" },
        {
          value: formatIndex(item.rules, "course"),
          align: "center"
        },
        {
          value: formatIndex(item.rules, "points"),
          align: "center"
        },
        {
          value: item.index
        },
        {
          value: item.sum
        }
      ]);
    });

    rows.push([
      {
        value: index - 1,
        font: {
          bold: true
        },
        align: "center"
      },
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {
        value: element.activitySum,
        font: {
          bold: true
        }
      }
    ]);
    totalCount += index - 1;
    totalSum += element.activitySum;
  });

  rows.push([]);
  rows.push([
    {
      value: totalCount,
      font: {
        bold: true
      },
      align: "center"
    },
    {},
    {},
    {},
    {},
    {},
    {},
    {},
    {
      value: totalSum,
      font: {
        bold: true
      }
    }
  ]);

  return rows;
}

async function downloadRatingData(id, name) {
  let data = await ratingReport(id);
  console.log(formatRows(data));
  await downloadXLS(formatRows(data), name);
}

export { downloadRatingData };
